export class ChangePasswordModel {
  username!: string;
  existingPassword!: string;
  password!: string;
  isSuccess!: boolean;
  message!: string;
  isLogOut!: boolean;
}
